import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: AppGeneralState = {
    isDemoMode: undefined,
    showKeyboard: true,
    isMobileView: false,
    showMobileDrawerMenu: undefined,
    showOrderAddedItemsBoxInMobileView: false,
    ordersListViewType: "grid",
    showDemoModeBtnLoader: false,
    showSelectOptionsModal: false,
    modalSelectOptionsList: [],
    showSettingsModal: false,
    showSendMenuLinModal: false,
    printMethod: "browser",
    autoPrint: false,
    printerSize: "58mm",
    selectAllPayablesByDefault: true,
};

const appSlice = createSlice({
    name: "appGeneral",
    initialState,
    reducers: {
        changeDemoModeState: (state, action: PayloadAction<{ isDemoMode?: boolean }>) => {
            const { isDemoMode = state.isDemoMode } = action.payload || {};
            state.isDemoMode = isDemoMode;
        },
        toggleMobileModeState: (state, action: PayloadAction<{ isMobileView?: boolean } | undefined>) => {
            const { isMobileView } = action.payload || {};
            if (isMobileView === undefined) return;
            state.isMobileView = isMobileView;
        },
        changeMobileDrawerMenuShowState: (state, action: PayloadAction<{ show?: boolean } | undefined>) => {
            const { show } = action.payload || {};
            state.showMobileDrawerMenu = show;
        },
        toggleSwapToOrderAddedItemsInMobileView: (state, action: PayloadAction<{ swapToOrderAddedItemsBox?: boolean } | undefined>) => {
            const { swapToOrderAddedItemsBox } = action.payload || {};
            // if (swapToOrderAddedItemsBox === undefined || !state.isMobileView) return;
            if (swapToOrderAddedItemsBox === undefined) return;
            state.showOrderAddedItemsBoxInMobileView = swapToOrderAddedItemsBox;
        },
        changeOrdersListViewType: (state, action: PayloadAction<{ viewType?: AppGeneralState["ordersListViewType"] } | undefined>) => {
            const { viewType } = action.payload || {};
            if (viewType === "grid" || viewType === "list") {
                state.ordersListViewType = viewType;
            }
        },
        setShowDemoModeBtnLoader: (state, action: PayloadAction<{ show?: boolean } | undefined>) => {
            const { show = state.showDemoModeBtnLoader } = action.payload || {};
            state.showDemoModeBtnLoader = show;
        },
        toggleSelectOptionsModal: (state, action: PayloadAction<{
            showModal?: boolean;
            selectTitle?: string;
            selectOptions?: CashBoxSelectOption[];
        } | undefined>) => {
            const {
                showModal = !state.showSelectOptionsModal,
                selectTitle = "",
                selectOptions = [],
            } = action.payload || {};

            state.showSelectOptionsModal = showModal;
            state.modalSelectTitle = selectTitle;
            state.modalSelectOptionsList = selectOptions;
        },
        toggleShowSettingsModal: (state, action: PayloadAction<{ showModal?: boolean } | undefined>) => {
            const { showModal = !state.showSettingsModal } = action.payload || {};
            state.showSettingsModal = showModal;
        },
        setShowKeyboardState: (state, action: PayloadAction<{ showKeyboard?: boolean } | undefined>) => {
            const { showKeyboard = state.showKeyboard } = action.payload || {};
            state.showKeyboard = showKeyboard;
        },
        setShowSendMenuLinkModal: (state, action: PayloadAction<boolean | undefined>) => {
            state.showSendMenuLinModal = !!action.payload;
        },
        setPrintMethodState: (state, action: PayloadAction<{ printMethod?: AppGeneralState["printMethod"] } | undefined>) => {
            const { printMethod = state.printMethod } = action.payload || {};
            state.printMethod = printMethod;
        },
        setPrinterSizeState: (state, action: PayloadAction<{ printerSize?: string }>) => {
            const { printerSize = state.printerSize } = action.payload || {};
            state.printerSize = printerSize;
        },
        setAutoPrintState: (state, action: PayloadAction<{ autoPrint?: boolean } | undefined>) => {
            const { autoPrint = state.autoPrint } = action.payload || {};
            state.autoPrint = autoPrint;
        },
        setSelectAllPayablesState: (state, action: PayloadAction<{ selectAllPayablesByDefault?: boolean } | undefined>) => {
            const {
                selectAllPayablesByDefault = state.selectAllPayablesByDefault,
            } = action.payload || {};
            state.selectAllPayablesByDefault = selectAllPayablesByDefault;
        },
    },
});

export const {
    changeDemoModeState,
    toggleMobileModeState,
    changeMobileDrawerMenuShowState,
    toggleSwapToOrderAddedItemsInMobileView,
    changeOrdersListViewType,
    setShowDemoModeBtnLoader,
    toggleSelectOptionsModal,
    toggleShowSettingsModal,
    setShowKeyboardState,
    setShowSendMenuLinkModal,
    setPrintMethodState,
    setAutoPrintState,
    setPrinterSizeState,
    setSelectAllPayablesState,
} = appSlice.actions;

export default appSlice.reducer;
